<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple">
  <p style="font-size: 15px; color: white;text-align: center;">{{'messages.loading' | translate}} </p>
</ngx-spinner>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">
              <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
              <app-fildariane></app-fildariane>
            </h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">{{'navigation.home' | translate}}</a></li>
                <li class="breadcrumb-item active">
                  <app-fildariane></app-fildariane>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->
      <div class="row">
      </div>
      <!-- end row -->
      <div class="row justify-content-between align-items-center">
        <a href="javascript:window.history.back();" class="btn btn-primary waves-effect waves-light btn-sm mb-3"><i class="mdi mdi-chevron-left ml-1"></i> {{'common.back' | translate}} </a>
        <div>
          <button type="button" class="btn btn-success waves-effect waves-light btn-sm mb-3" (click)="exporterExcel()">
            <i class="bx bx-export font-size-16 align-middle mr-2"></i> {{'common.exportCsv' | translate}}
          </button>
          <button type="button" class="btn btn-danger waves-effect waves-light btn-sm mb-3 ml-2" (click)="exporterPdf()">
            <i class="bx bxs-file-pdf font-size-16 align-middle mr-2"></i> {{'common.exportPdf' | translate}}
          </button>
        </div>

        <div class="card col-lg-12" #pdfExportArea>
          <div class="card-body">
            <div class="container-fluid mobile_container">
              <div class="row text-left">
                <div class="col-md-2 col-lg-3"> <span class="card-title label_info">{{'fields.employeeId' | translate}} </span> : {{user_details.matricule}}</div>
                <div class="col-md-2 col-lg-3"> <span class="card-title label_info">{{'fields.lastName' | translate}} </span> : {{user_details.name}}</div>
                <div class="col-md-2 col-lg-3">  <span class="card-title label_info">{{'fields.firstName' | translate}} </span> : {{user_details.firstname}}</div>
                <div class="col-md-2 col-lg-3"> <span class="card-title label_info">{{'fields.service' | translate}} </span> : {{user_details.service ? user_details.service : 'Non défini'}}</div>
                <div class="col-md-2 col-lg-3"> <span class="card-title label_info">{{'fields.startDate' | translate}} </span> : {{formatUserDate(user_details.start_date)}}</div>
                <div class="col-md-2 col-lg-3"> <span class="card-title label_info">{{'fields.endDate' | translate}} </span> : {{formatUserDate(user_details.end_date)}}</div>
              </div>
            </div>
          </div>
          <div class="alert-left-establishment" *ngIf="entityType == 'IP' && hasLeftEstablishment()">
            {{'certificates.personLeft' | translate}}
          </div>
          <div class="container-fluid mobile_container">
            <div class="row head_row text-left">
              <div class="col-w-cert tt_nom_certif only_pc">
                <div class="row">
                  <div class="col-12 legend-toggle" (click)="toggleColumnLegend()" [attr.title]="'aria.toggleColumnDetails' | translate">
                    <i class="bx bxs-bookmark"></i> {{'navigation.certifications' | translate}}
                    <i class="bx sort-icon" [ngClass]="showColumnLegend ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
                  </div>
                  <ng-container *ngIf="showColumnLegend">
                    <div class="col-12">
                      <i class="bx bxs-graduation ml-3" style="margin-left: 42px"></i> {{'fields.courseTitle' | translate}}
                    </div>
                    <div class="col-12">
                      <i class="bx bx-bookmark" style="margin-left: 32px"></i> {{'fields.subCertificate' | translate}}
                    </div>
                    <div class="col-12">
                      <i class="bx bxs-graduation" style="margin-left: 46px"></i> {{'fields.courseTitle' | translate}}
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="col-w-statut-cert tt_valid_certif only_pc" [ngClass]="{'align-self-start': showColumnLegend}">
                <div class="row">
                  <div class="col-12 sortable-header" (click)="sortBy('status')" [attr.title]="'aria.sortCertificateStatus' | translate">
                    <i class="bx bxs-bookmark"></i> {{'fields.registrationStatus' | translate}}
                    <i class="bx sort-icon" [ngClass]="sortField === 'status' ? (sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down') : 'bx-sort-alt-2'"></i>
                  </div>
                </div>
              </div>
              <div class="col-w-statut-parcours tt_date_certif only_pc">
                <div class="row">
                  <div class="col-12">
                                              <i class="bx bxs-graduation"></i> {{'fields.courseStatus' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-w-duree tt_valid_certif only_pc">
                <div class="row">
                  <div class="col-12">
                    <i class="bx bx-time"></i> {{'fields.validityDuration' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-w-date-cert tt_date_certif only_pc">
                <div class="row">
                  <div class="col-12 sortable-header" (click)="sortBy('date_certification')" [attr.title]="'aria.sortCertificationDate' | translate">
                    <i class="bx bx-calendar"></i> {{'fields.certificationDate' | translate}}
                    <i class="bx sort-icon" [ngClass]="sortField === 'date_certification' ? (sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down') : 'bx-sort-alt-2'"></i>
                  </div>
                </div>
              </div>
              <div class="col-w-date-fin tt_date_certif only_pc">
                <div class="row">
                  <div class="col-12 sortable-header" (click)="sortBy('date_fin')" [attr.title]="'aria.sortValidityEndDate' | translate">
                    <i class="bx bx-calendar"></i> {{'fields.validityEndDate' | translate}}
                    <i class="bx sort-icon" [ngClass]="sortField === 'date_fin' ? (sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down') : 'bx-sort-alt-2'"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="alert alert-danger" role="alert" *ngIf="certificats && certificats?.length === 0">
              <p style="text-align: center; margin:20px 0 20px 0;">{{'certificates.noneForLearner' | translate}}</p>
            </div>
            <div class="row list_scroll">
              <div class="row text-left certif_wrap" *ngFor="let certification of certificats; let i = index;" [ngClass]="{'no-border': i === 0}">
                <div class="cert-title-row">
                  <div class="cert col-w-cert">
                    <div class="icon-wrapper">
                      <i class="bx bxs-bookmark"></i>
                    </div>
                    <div class="text-wrapper">
                      <span class="only_mobile">{{'navigation.certifications' | translate}} : </span>
                      <span class="label_cert">{{certification.certificat_name}}</span>
                    </div>
                  </div>
                  <div class="col-w-statut-cert status-cell">
                      <ng-container *ngIf="certification.certificat_statut == 'Valide'">
                        <span class="badge badge-valid">{{'status.valid' | translate}}</span>
                        <span class="badge badge-expiring ml-1" *ngIf="certificationExpiringSoon(certification)" [attr.title]="'aria.expiresWithinMonth' | translate">
                          <i class="bx bx-time-five"></i> {{'status.expiringSoon' | translate}}
                        </span>
                      </ng-container>
                      <ng-container *ngIf="certification.certificat_statut == 'Non Valide'">
                        <span class="badge badge-no-valid">{{certificationNonValidLabel(certification)}}</span>
                      </ng-container>
                      <ng-container *ngIf="certification.certificat_statut == 'Invalidé'">
                        <span class="badge badge-no-valid">{{'status.invalid' | translate}}</span>
                      </ng-container>
                    </div>
                    <div class="col-w-statut-parcours"> </div>
                    <div class="col-w-duree">
                      <span class="only_mobile">{{'fields.validityDuration' | translate}} </span>{{certification.certificat_type_validite === 2 ? certification.certificat_delay + " mois" : certification.certificat_date }}
                    </div>
                    <div class="col-w-date-cert">
                      <span class="col_date">
                        <span class="only_mobile">{{'fields.certificationDate' | translate}} </span>{{getCertificationValidationDate(certification)}}
                      </span>
                    </div>
                    <div class="col-w-date-fin">
                      <span class="col_date">
                        <span class="only_mobile">{{'fields.validityEndDate' | translate}} </span>{{getCertificationEndDate(certification)}}
                      </span>
                    </div>
                </div>

                  <ng-container *ngFor="let parcours_result of certification.parcours_result; let k = index">
                    <ng-container *ngIf="parcours_result && parcours_result?.length != 0">

                      <div class="cert col-w-cert" [ngClass]="{'parcours-cell': parcours_result.status_label !== 'valide'}">
                        <!-- Icône placée dans une div séparée -->
                        <div class="ml-3 icon-wrapper">
                          <i class="bx bxs-graduation"></i>
                        </div>
                        <!-- Texte placé à côté de l'icône -->
                        <div class="text-wrapper">
                          <span class="only_mobile">{{'fields.courseTitle' | translate}} : </span>
                          <span class="titre_parcours">{{parcours_result.parcour_label}}</span>
                        </div>
                      </div>
                      <div class="col-w-statut-cert" [ngClass]="{'parcours-cell': parcours_result.status_label !== 'valide'}"></div>
                      <div class="col-w-statut-parcours" [ngClass]="{'parcours-cell': parcours_result.status_label !== 'valide'}">{{formatStatusLabel(parcours_result.status_label)}}</div>
                      <div class="col-w-duree" [ngClass]="{'parcours-cell': parcours_result.status_label !== 'valide'}"></div>
                      <div class="col-w-date-cert" [ngClass]="{'parcours-cell': parcours_result.status_label !== 'valide'}">
                                <span class="col_date">
                                <span class="only_mobile">{{'fields.certificationDate' | translate}} </span>{{parcours_result.date_validation}}</span>
                      </div>
                      <div class="col-w-date-fin" [ngClass]="{'parcours-cell': parcours_result.status_label !== 'valide'}">
                                <span class="col_date">
                                  <ng-container *ngIf="parcours_result.lesson_status=='not validated'"><span class="col_valid not_attempted"><i class="bx bx-info-circle"></i> NC</span></ng-container>
                                  <ng-container *ngIf="parcours_result.lesson_status!='not validated'"><span class="only_mobile">{{'fields.validityEndDate' | translate}} </span>{{parcours_result.date_fin_validite}}</ng-container>
                                </span>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="parcours_result && parcours_result?.length === 0">
                      <div class="col-md-2 col-lg-2"></div>
                      <div class="col-md-2 col-lg-2"></div>
                      <div class="col-md-1 col-lg-1"></div>
                      <div class="col-md-2 col-lg-1"></div>
                      <div class="col-md-2 col-lg-1"></div>
                    </ng-container>
                  </ng-container>

                <ng-container *ngIf="certification.sub_certifications && certification.sub_certifications?.length != 0">
                  <ng-container *ngFor="let sub_certifications of certification.sub_certifications; let k = index">
                    <div class="cert col-w-cert">
                      <!-- Icône placée dans une div séparée -->
                      <div class="icon-wrapper">
                        <i class="bx bx-bookmark" style="margin-left: 29px"></i>
                      </div>
                      <!-- Texte placé à côté de l'icône -->
                      <div class="text-wrapper">
                        <span class="only_mobile">{{'fields.subCertificate' | translate}} : </span>
                        <span>{{sub_certifications.sub_certificat_name}}</span>
                      </div>
                    </div>
                    <div class="col-w-statut-cert status-cell">


                    </div>
                    <div class="col-w-statut-parcours"> </div>
                    <div class="col-w-duree">
                    </div>
                    <div class="col-w-date-cert">
                      <span class="col_date">
                      </span>
                    </div>
                    <div class="col-w-date-fin">
                      <span class="col_date">
                      </span>
                    </div>
                    <ng-container *ngFor="let sub_certificat_result of sub_certifications.sub_certificat_result; let k = index">
                      <div class="cert col-w-cert" [ngClass]="{'parcours-cell': sub_certificat_result.status_label !== 'valide'}">
                        <!-- Icône placée dans une div séparée -->
                        <div class="ml-3 icon-wrapper">
                          <i class="bx bxs-graduation" style="margin-left: 27px"></i>
                        </div>
                        <!-- Texte placé à côté de l'icône -->
                        <div class="text-wrapper">
                          <span class="only_mobile">{{'fields.courseTitle' | translate}} : </span>
                          <span class="titre_parcours">{{sub_certificat_result.parcour_label}}</span>
                        </div>
                      </div>
                      <div class="col-w-statut-cert" [ngClass]="{'parcours-cell': sub_certificat_result.status_label !== 'valide'}"></div>
                      <div class="col-w-statut-parcours" [ngClass]="{'parcours-cell': sub_certificat_result.status_label !== 'valide'}">
                            <span class="col_valid">
                              {{formatStatusLabel(sub_certificat_result.status_label)}}
                            </span>
                      </div>
                      <div class="col-w-duree" [ngClass]="{'parcours-cell': sub_certificat_result.status_label !== 'valide'}"></div>

                      <div class="col-w-date-cert" [ngClass]="{'parcours-cell': sub_certificat_result.status_label !== 'valide'}">
                                <span class="col_date">
                                <span class="only_mobile">{{'fields.certificationDate' | translate}} </span>{{sub_certificat_result.date_validation}}
                                </span>
                      </div>
                      <div class="col-w-date-fin" [ngClass]="{'parcours-cell': sub_certificat_result.status_label !== 'valide'}">
                            <span class="col_date">
                            <ng-container *ngIf="sub_certificat_result.lesson_status=='not validated'"><span class="col_valid not_attempted"><i class="bx bx-info-circle"></i> NC</span></ng-container>
                              <ng-container *ngIf="sub_certificat_result.lesson_status!='not validated'"><span class="only_mobile">{{'fields.validityEndDate' | translate}} </span>{{sub_certificat_result.date_fin_validite}}</ng-container>
                            </span>
                      </div>
                    </ng-container>
                  </ng-container>

                </ng-container>
              </div>
            </div>
          </div>

        </div>
        <!-- end row -->
      </div>
      <!-- container-fluid -->
    </div>
  </div>
</div>
<!-- End Page-content -->
<app-footer></app-footer>
